import type { AxiosError } from 'axios'

export type KibsiErrorData = {
    message: string
    errorCode?: string
    additionalDetails?: unknown
}

export class KibsiHttpError extends Error {
    readonly statusCode?: number
    readonly errorCode?: string
    readonly additionalDetails?: unknown
    readonly requestId?: string
    readonly url?: string

    constructor(err: AxiosError) {
        super(getMessage(err))

        if (err.response) {
            const { data } = err.response
            const { errorCode, additionalDetails } = data as KibsiErrorData
            this.statusCode = err.response.status
            this.errorCode = errorCode
            this.requestId = err.config?.headers?.['x-kibsi-request-id']
            this.additionalDetails = additionalDetails
        }

        if (err.request) {
            this.url = err.request.responseURL as string
        }
    }
}

function getMessage(err: AxiosError): string | undefined {
    const data = err.response?.data

    if (typeof data === 'string') {
        return data
    }

    if (hasMessage(data)) {
        return data.message
    }

    return undefined
}

function hasMessage(value: unknown): value is Pick<KibsiErrorData, 'message'> {
    return typeof value === 'object' && Object.keys(value ?? {}).includes('message')
}
